// 语言包，中文
export default {
    userName: "用戶名稱",
    requiredUserName: "用戶名稱不能為空",
    returnHome: "返回官網",
    changePassword: "修改密碼",
    logout: "退出登錄",
    changeLanguage: "修改語言",
    saveChange: "記住我的選擇",
    languageName: "選擇語言",
    cancelData: "取消",
    confirmData: "確定",
    muchMoreTabs: "您已经打开了太多的菜单，先关掉几个吧",
    notice: "提示",
    userInfo: "个人信息",
    changeRole: "切换角色",
    viewVersion: "查看版本",
    helps: "帮助文档",
    indexName: "序号",
    setColumnName: "设置列表字段",
    closeAllTabs: "关闭全部标签",
    closeOtherTabs: "关闭其它标签",
    closeLeftTabs: "关闭左侧标签",
    closeRightTabs: "关闭右侧标签",
    refreshPage: "刷新页面",
}